import { Stack, Box, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';
import QuestionLabel from './QuestionLabel';
import { fieldSx } from './formTheme';
import { useTranslation } from 'react-i18next';

export default function PersonalInfoForm() {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const attendedPreviousEdition = watch('general.attendedPreviousEdition');

  const fields = [
    {
      type: 'text',
      label: t('certificate_name'),
      name: 'general.certificateName',
    },
    { type: 'text', label: t('full_name'), name: 'general.fullName' },
    { type: 'text', label: t('preferred_name'), name: 'general.preferredName' },
    {
      type: 'text',
      label: t('instagram_profile'),
      name: 'general.instagramProfile',
    },
    { type: 'email', label: t('email'), name: 'general.email' },
    { type: 'email', label: t('confirm_email'), name: 'general.confirmEmail' },
    // { type: 'number', label: t('phone_number'), name: 'general.phoneNumber' },
    {
      type: 'select',
      label: t('shirt_size'),
      name: 'general.shirtSize',
      options: [
        { label: 'XS', value: 'XS' },
        { label: 'S', value: 'S' },
        { label: 'M', value: 'M' },
        { label: 'L', value: 'L' },
        { label: 'XL', value: 'XL' },
        { label: 'XXL', value: 'XXL' },
      ],
    },
    {
      type: 'textarea',
      label: t('emergency_contact'),
      name: 'general.emergencyContact',
      alternateLabel: true,
    },
    {
      type: 'radio',
      label: t('age'),
      name: 'general.age',
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('attended_previous_edition'),
      name: 'general.attendedPreviousEdition',
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'textarea',
      label: t('image_consent'),
      name: 'general.imageConsent',
      alternateLabel: true,
    },
  ];

  if (attendedPreviousEdition === 'NIE') {
    fields.push(
      { type: 'text', label: t('travel_method'), name: 'general.travelMethod' },
      {
        type: 'radio',
        label: t('use_whatsapp'),
        name: 'general.useWhatsApp',
        options: [
          { label: t('yes'), value: 'TAK' },
          { label: t('no'), value: 'NIE' },
        ],
      },
      {
        type: 'radio',
        label: t('allow_group_contact'),
        name: 'general.allowGroupContact',
        options: [
          { label: t('yes'), value: 'TAK' },
          { label: t('no'), value: 'NIE' },
        ],
      },
    );
  }

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 4,
        }}
      >
        {fields.map((field) => (
          <Box key={field.name} sx={fieldSx(field, mobileScreen)}>
            <QuestionLabel
              component='label'
              sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}
              collapsible={!(field.alternateLabel || mobileScreen)}
            >
              {field.label}
            </QuestionLabel>
            <FormField
              {...field}
              label={null}
              ariaLabel={
                typeof field.label === 'string' ? field.label : undefined
              }
              register={register}
              error={errors?.general?.[field.name.split('.')[1]]}
              helperText={errors?.general?.[field.name.split('.')[1]]?.message}
              fullWidth
            />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
